/**
 * DotPlot component barrel export
 *
 * Dot plot visualization for comparing metrics.
 */

export { default } from "./DotPlotView";
